import axios from 'axios';
import { AccessKey } from '@cabinet-packages/helpers';

const env = process.env.REACT_APP_API_PATH || '/api/agent';

export const createOrderWithInsurance = async (
    num,
    idClient,
    idDoctor,
    services,
    idPunkt,
    date,
    note,
    insuranceInfo = {}
) => {
    const accessKey = AccessKey.get();

    if (!accessKey) return;

    const today = new Date().toISOString().slice(0, 10) + ' 00:00:00.0';
    const dateValid = date || today;

    const data = {
        num,
        idPunkt,
        idClient,
        dt: today,
        agentInfo: {
            dateValid,
            vaucher: insuranceInfo.vaucher || '',
            payment: insuranceInfo.payment || 0,
        },
        payment: insuranceInfo.clinicPay ? 'bank' : 'cash',
        note,
        idDoctor,
        services,
    };

    const result = await axios.post(env + 'createOrder', data, {
        headers: {
            Authorization: 'Bearer ' + accessKey,
        },
    });

    return result.data;
};
